import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  private baseUrl = environment.url3;

  constructor(private http: HttpClient) { }

  getFile(id: string): Observable<any> {
    // Prepare the request URL
    const url = `${this.baseUrl}/file/view/${id}`;
    
    return this.http.get(url, {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Accept': 'application/octet-stream',
        'Autorizzazione':localStorage.getItem('token')
      })
    });
  }

  // Method to delete a file by ID
  deleteFile(id: string): Observable<any> {
    const headers = new HttpHeaders()
      .append('Autorizzazione', localStorage.getItem('token'));

      return this.http.delete(`${this.baseUrl}/file/delete/${id}`,{ headers }).pipe( map( data => data));
    }

}

